export * from './gen/bank-portal-api';
